// 2026 design: in the scorecard modal, the top bar + team panel lock while the
// holes scroll, and the phone table's header row locks directly beneath them.
// The header needs that block's height, which varies with name length, so it
// is measured here and published as --sc-sticky-h on the [data-scorecard]
// wrapper (components.scss). Standalone scorecard pages do not lock the block,
// so they get no offset. Presentation only.
function syncScorecardSticky(root) {
  (root || document).querySelectorAll('.modal [data-scorecard]').forEach(function (scorecard) {
    const block = scorecard.querySelector('.faso-scorecard-sticky');
    if (!block) return;

    const publish = function () {
      scorecard.style.setProperty('--sc-sticky-h', block.offsetHeight + 'px');
    };
    publish();
    if (window.ResizeObserver && !block.dataset.stickyObserved) {
      block.dataset.stickyObserved = 'true';
      new ResizeObserver(publish).observe(block);
    }
  });
}

// team_rounds_modal.js announces each scorecard it loads.
document.addEventListener('faso:modal-loaded', function (event) {
  syncScorecardSticky(event.detail);
});
